// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ly-6";
export var imgContainer = "_ly-3";
export var menuIcon = "_ly-5";
export var pillWrapper = "_ly-2";
export var pillsContainer = "_ly-1";
export var subscriptionCard = "_ly-0";
export var subscriptionLogo = "_ly-4";